import { useRouter } from 'next/router';
import type { TimeControl } from '@packages/cms-components/interfaces';
import { dateCompare } from './dateCompare';

export const filterTimeControl = (
  item: TimeControl,
  testDate: string | string[] | undefined | null = undefined,
): boolean => {
  // support valid from and valid until fields from paragraphs and content snippets INSPIRE-2298
  const {
    field_valid_from: validFrom,
    field_valid_to: validTo,
    field_valid_until: validUntil,
    field_visible_from: visibleFrom,
    field_visible_until: visibleUntil,
  } = item;

  return dateCompare({
    validFrom: validFrom || visibleFrom,
    validTo: validTo || visibleUntil || validUntil,
    testDate: Array.isArray(testDate) ? testDate[0] : testDate,
  });
};

export const useFilterTimeControl = (): ((item: TimeControl) => boolean) => {
  const { query } = useRouter();
  const { TestDate } = query;
  return (item: TimeControl): boolean => filterTimeControl(item, TestDate);
};
